import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const Wrapper = styled.div`
	max-height: 90vh;
	overflow: auto;

	.DayPicker-Day {
		position: relative !important;

		::after {
			position: absolute !important;
			margin-left: auto !important;
			margin-right: auto !important;
			left: 0 !important;
			right: 0 !important;
			text-align: center !important;
		}
	}
`;

export const ContainerSubtitles = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	margin-top: 320px;
`;

export const ContainerButton = styled.div`
	background-color: white;
	z-index: ${tokens.zindex_tooltip};
	width: 280px;
	position: absolute;
	display: flex;
	justify-content: space-between;
	gap: 24px;
	bottom: 40px;
`;

export const ContainerHour = styled.div`
	display: flex;
	margin-top: 42px;
	margin-bottom: 80px;
	align-items: center;
	gap: 12px;
`;

export const TextHour = styled.p`
	font-family: ${tokens.font_family_primary};
	font-weight: 400;
	font-size: 14px;
	color: ${tokens.color_gray_dark};
`;
